import React, { Fragment } from 'react';
import Head from 'next/head';
import { observer } from 'mobx-react';
import { Disclosure, Menu, Transition } from '@headlessui/react';
import { MailIcon, PhoneIcon, ChevronDownIcon } from '@heroicons/react/outline';
import { makeObservable } from 'mobx';
import 'tailwindcss/tailwind.css';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { Store } from '../../pagepart/store/Store';
import { StoreContext } from 'src/pagepart/utils';
import { Env } from '../../env/Env';
import { ServerProps } from '../../pagepart/portal/utils';
import { TopbarNavigationDropdown } from '../../tailwind/info/TopbarNavigationDropdown';
import { InfoTopbar } from '../../tailwind/info/InfoTopbar';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export async function getServerSideProps(rawContext) {
  const { env, userEnv, requestEnv } = await Env.forNextContext(rawContext);

  return {
    props: {
      ...env.transfer,
    },
  };
}

const faqs = [
  {
    question: 'Ist Schlaukopf wirklich kostenlos?',
    answer: (
      <span>
        Ja, Schlaukopf ist kostenlos und finanziert sich mit Werbeanzeigen.
        <br />
        Optional bieten wir ein werbefreies Premium Upgrade mit zusätzlichen Funktionen und Inhalten an.
      </span>
    ),
  },
  {
    question: 'Wie kann man die Schwierigkeitsstufe einstellen?',
    answer: 'Die Schwierigkeitsstufe passt sich individuell und automatisch an.',
  },
  {
    question: 'Welche Web-Browser werden unterstützt?',
    answer: (
      <span>
        Wir unterstützen die <b>aktuellsten Versionen</b> der gängigen Web-Browser Chrome, Firefox, Edge und Safari.
      </span>
    ),
  },
  {
    question: 'Was bietet die Premium-Version?',
    answer: <span>Die Premium Version bietet werbefreiheit und zusätzliche Funktionen und Inhalte.</span>,
  },
  {
    question: 'Gibt es eine Schullizenz?',
    answer: <span>Ja, eine Schullizenz kostet 399 € pro Jahr (inkl. MwSt) und kann über schullizenz@schlaukopf.de gebucht werden. Eine Schullizenz ist für die Nutzung von Schlaukopf in Schulen aus datenschutzrechtlicher Sicht erforderlich, unter anderem da für die schulische Nutzung werbefreiheit gewährleistet sein muss. Die Aktivierung erfolgt sehr einfach per Freischaltcode oder IP-Netz-Freischaltung.</span>,
  },
  // More questions...
];

@observer
class InfoImpressum extends React.Component<ServerProps<typeof getServerSideProps>> {
  constructor(props) {
    super(props);
    // makeObservable(this);
  }

  @memoize
  get store() {
    return Store.forApp(this);
  }

  setupPage(store: Store) {
    store.portalStore.metaTitle = 'Schlaukopf Impressum';
  }

  render() {
    const { userData } = this.props;

    return (
      <StoreContext.Provider value={this.store}>
        <Head>
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
          <title>Schlaukopf - Häufige Fragen</title>
          <meta name="Description" content="Häufige Fragen zur  Lernplattform Schlaukopf." />
          <meta name="Keywords" content="Schlaukopf,Häufige Fragen,FAQ" />
          <meta name="Language" content="de" />
          <meta name="robots" content="index,follow" />
        </Head>
        <div className="antialiased font-sans  bg-gray-50" style={{ minHeight: '100vh' }}>
          <InfoTopbar />
          <div>
            <main>
              <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                {/* Replace with your content */}
                <div className="bg-white">
                  <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-20 lg:px-8">
                    <div className="lg:grid lg:grid-cols-3 lg:gap-8">
                      <div>
                        <h2 className="text-3xl font-extrabold text-gray-900">Häufige Fragen</h2>
                        <p className="mt-4 text-lg text-gray-500">
                          Falls du keine Antwort auf deine Frage finden kannst, kannst du uns&nbsp;
                          <a href="/info/impressum" className="font-medium text-indigo-600 hover:text-indigo-500">
                            kontaktieren
                          </a>
                          .
                        </p>
                      </div>
                      <div className="mt-12 lg:mt-0 lg:col-span-2">
                        <dl className="space-y-12">
                          {faqs.map(faq => (
                            <div key={faq.question}>
                              <dt className="text-lg leading-6 font-medium text-gray-900">{faq.question}</dt>
                              <dd className="mt-2 text-base text-gray-500">{faq.answer}</dd>
                            </div>
                          ))}
                        </dl>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /End replace */}
              </div>
            </main>
          </div>
        </div>
      </StoreContext.Provider>
    );
  }
}

export default InfoImpressum;
